// extracted by mini-css-extract-plugin
export var carrierIcon = "_ws-0";
export var carrierLogo = "_ws-1";
export var detailsSection = "_ws-2";